export enum EnumCadastro {
  CLIENTE = 1,
  ITEM = 2,
}
